import axios from "axios";

// Our backend (Render free plan) falls asleep when nobody visits. The first request after that
// can fail or take 1-2 minutes while it wakes up. Instead of showing an error, we try again
// automatically and show a "waking up" message (see ServerWakeBanner).

const TRY_TIMEOUT_MS = 25000; // give up on one try after 25 seconds
const RETRY_DELAY_MS = 3000;  // wait 3 seconds between tries
const MAX_TRIES = 8;          // about 3.5 minutes in the worst case

// --- tell the banner when we are waiting for the server ---
const listeners = new Set();
let waitingRequests = 0;

function changeWaiting(delta) {
  waitingRequests += delta;
  listeners.forEach((listener) => listener(waitingRequests > 0));
}

// Call listener(true/false) whenever "server is waking up" starts or stops. Returns an unsubscribe function.
export function onServerWaking(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Same as axios.get(url), but tries again while the server is waking up.
export async function getWithRetry(url) {
  let waiting = false;
  try {
    for (let attempt = 1; ; attempt++) {
      try {
        return await axios.get(url, { timeout: TRY_TIMEOUT_MS });
      } catch (err) {
        const status = err.response && err.response.status;
        // No answer, timeout or 5xx = server probably still starting -> try again.
        // 4xx (e.g. 404 deal not found) = a real answer -> don't retry.
        const serverStarting = !status || status >= 500;
        if (!serverStarting || attempt >= MAX_TRIES) {
          throw err;
        }
        if (!waiting) {
          waiting = true;
          changeWaiting(1);
        }
        await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
      }
    }
  } finally {
    if (waiting) {
      changeWaiting(-1);
    }
  }
}
